import React, { useEffect, useMemo } from 'react'
import DatasetButton from '../../ui/alternativeData/DatasetButtonWithExternalLabel'
import SelectWithExternalLabel from '../../ui/SelectWithExternalLabel'
import ScreenerFiltersChange from './ScreenerFiltersChange'
import { DatasetProvider, useDataset } from '../../../context/dataset'
import useScreenerFilters from '../hooks/useScreenerFilters'
import { useScreenerContext } from '../context/useScreenerContext'
import { IconButton, Typography } from '@mui/material'
import { getColumnsOfDatasets as getColumns} from '../../../utils/tools'
import { ClearSharp }from '@mui/icons-material'
import styles from './ScreenerFiltersModal.module.scss'

export default function SectionAlternativeData({datasets, dataset}) {
    const { addAlternativeData, handleUpdateDataset, handleUpdateSelect,removeTopBottomLimitsOnOptions,updateTopBottomLimitOn } = useScreenerContext()
    const limit = 3

    const container = useMemo(() => dataset.map(
        (_, index) => {
            const props = { datasets, dataset, index, handleUpdateDataset, getColumns, key:`${dataset[index]?.datasetValue}-${index}`}
            return <DatasetProvider {...props}>
                    <Dataset {...props} handleUpdateSelect={handleUpdateSelect} updateTopBottomLimitOn={updateTopBottomLimitOn} removeTopBottomLimitsOnOptions={removeTopBottomLimitsOnOptions} currentDataset={dataset[index]}/>
                </DatasetProvider>
            }
    ),[dataset, datasets, handleUpdateDataset]) // eslint-disable-line

    return (
        <div className={styles['alterantive-data-container']}>
            {container}
            {dataset.length < limit && <Typography onClick={addAlternativeData} classes={{root: styles['add-data']}}>+ Add another Alternative Data</Typography>}
        </div>

    )
}


const Dataset = ({index, currentDataset, handleUpdateSelect,removeTopBottomLimitsOnOptions,updateTopBottomLimitOn, ...props}) => {
    const { columns , changeColumn, datasets, changeDataset, removeDataset, originalFrequency } = useDataset()
    const { selectRole, selectTimePeriod, defaultFrequency } = useScreenerFilters(originalFrequency)
    const btnProps = {index, columns , changeColumn, datasets, changeDataset, currentDataset}

    useEffect(() => {(defaultFrequency && !currentDataset.forTimeperiod) && handleUpdateSelect({name:'forTimeperiod',value: defaultFrequency}, index);return () => {}}
        ,[defaultFrequency, currentDataset.forTimeperiod, handleUpdateSelect, index, selectTimePeriod])

    const updateSelect = (data) => {
        handleUpdateSelect(data, index);
    }

    return (
        <div className={styles['alternative-data-fields']}>
            <div className={styles['limit-size']}>
                <DatasetButton elevation={5} {...btnProps} {...props} />
            </div>
            <SelectWithExternalLabel label='Role' options={selectRole} value={currentDataset.rule} setValue={updateSelect} fieldName='rule'/>
            <div className={styles['change']}>
                <ScreenerFiltersChange label='change' rule={currentDataset.rule} value={currentDataset.change} setValue={updateSelect} fieldName='change'/>
            </div>
            <SelectWithExternalLabel label='For Timeperiod' options={selectTimePeriod} value={currentDataset.forTimeperiod || defaultFrequency} setValue={updateSelect} fieldName='forTimeperiod'/>
            <IconButton onClick={()=>{removeTopBottomLimitsOnOptions(currentDataset.columnValue);updateTopBottomLimitOn({'label':'','value':''});removeDataset()}} classes={{root: styles['remove-btn']}}>
                <ClearSharp/>
            </IconButton>
        </div>
       
    )
}

